
<div class="main-container">

    @if(isLoggedIn) {
      <div>
        <app-tfa
          (backToLoginPageEvent)="backToLoginPage()"
          (loginEvent)="login($event)"
          [tfaInputData]="tfaData"
          [isTfaConfigured]="isTfaConfigured"
        />
      </div>
    }  @else {

      <div class="text-2xl text-gray-900 my-3">
        Welcome back
      </div>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="flex flex-column gap-3 login-form">

        <div class="flex flex-column flex-1 ">
          <label for="email" class="text-xs font-medium mb-1">Email</label>
          <input
            type="text"
            id="email"
            pInputText
            placeholder="Enter your work email"
            formControlName="email"
            [class.ng-invalid]="loginForm.get('email')?.touched && loginForm.get('email')?.invalid"
            (blur)="loginForm.get('email')?.markAsTouched()"
          />
          @if(loginForm.get('email')?.touched && loginForm.get('email')?.invalid){
            <app-form-error-message
              [formGroup]="loginForm"
              fieldName="email"
              displayName="Email" />
          }
        </div>

        <div class="flex flex-column flex-1 ">
          <label for="password" class="text-xs font-medium mb-1">Password</label>
          <p-password
            type="password"
            id="password"
            placeholder="Enter password"
            formControlName="password"
            styleClass="w-full"
            [inputStyleClass]="(loginForm.get('password')?.touched && loginForm.get('password')?.invalid) ? 'ng-invalid' : ''"
            [toggleMask]="true"
            [feedback]="false"
            (onBlur)="loginForm.get('password')?.markAsTouched()"
          />
          @if(loginForm.get('password')?.touched && loginForm.get('password')?.invalid){
            <app-form-error-message
              [formGroup]="loginForm"
              fieldName="password"
              displayName="Password" />
          }
        </div>
        <button type="submit" pButton class="w-full flex justify-content-center" [disabled]="loginForm.invalid || isSubmitting">
          @if (isSubmitting) {
            <i class="pi pi-spin pi-spinner mr-2"></i> Signing In...
          }@else {
            Sign In
          }
        </button>
      </form>
  }
  @if(!isLoggedIn){
    <div
      class="text-xs font-medium underline text-primary cursor-pointer mt-3"
      (click)="handleForgotPassword()"
      >
        Forgot Password ?
    </div>
  }

  @if(isSetIdpProvider && !isLoggedIn) {
    <p-divider [align]="'center'" type="solid" styleClass="text-xs text-gray-700">
    <b>OR</b>
    </p-divider>

    <div class="text-sm flex justify-content-center mt-3" >
        <a [href]="ssoUrl" class="sso-button text-sm font-medium no-underline bg-gray-200 text-gray-700 border-round w-full text-center">
          Sign In with SSO
        </a>
    </div>
  }

</div>
